import Vue from 'vue';
import VueRouter from 'vue-router';

import presupuestoRouter from '../views/presupuestos/router';
import pagosRouter from '../views/pagos/router';
import comisionesRouter from '../views/comisiones/router';
import calificacionesRoutes from '../views/academico/calificaciones/routers';
// import gastosRoutes from '../views/gastos/routes';
import documentosInscripcionesRoutes from '../views/academico/documentos-inscripciones/routes';
import docentesSeguimientoRoutes from '../views/docentes/seguimiento/routers';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '@/Login.vue'),
  },
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue'),
  },
  { path: '/Sucursales', name: 'sucursales', component: () => import('../views/Sucursales/Index.vue') },
  { path: '/Dosificaciones', name: 'dosificaciones', component: () => import('../views/Dosificacion/Index.vue') },
  { path: '/Nits', name: 'nits', component: () => import('../views/Nits/Index.vue') },
  {
    path: '/recibos',
    name: 'recibos',
    component: () => import('../views/recibos/RecibosList.vue'),
  },
  {
    path: '/recibosl',
    name: 'recibosl',
    component: () => import('../views/recibos/RecibosLista.vue'),
  },
  {
    path: '/recibosl2',
    name: 'recibosl2',
    component: () => import('../views/RecibosEsamLista.vue'),
  },
  {
    path: '/ranking',
    name: 'ranking',
    component: () => import('../views/Ranking.vue'),
  },
  {
    path: '/rankingall',
    name: 'rankingall',
    component: () => import('../views/Rankingeneral.vue'),
  },
  {
    path: '/programas',
    name: 'programas',
    component: () => import('../views/programas.vue'),
  },
  {
    path: '/programas-esam',
    name: 'programas-esam',
    component: () => import('../views/ProgramasEsam.vue'),
  },
  {
    path: '/efectivos',
    name: 'dashboard.efectivos',
    component: () => import('../views/dashboard/Efectivos.vue'),
  },
  {
    path: '/viewProgramaModules',
    name: 'enroll.module',
    component: () => import('../views/academico/viewProgramaModules.vue'),
  },
  {
    path: '/programasadd',
    name: 'programasadd',
    component: () => import('../views/programa-add.vue'),
  },
  {
    path: '/postgrados',
    name: 'postgrados',
    component: () => import('../views/postgrados/Postgrados.vue'),
  },
  {
    path: '/postgradoadd',
    name: 'postgradoadd',
    component: () => import('../views/postgrados/Postgrado-add.vue'),
  },
  {
    path: '/postgradomod',
    name: 'postgradomod',
    component: () => import('../views/postgrados/Postgrado-mod.vue'),
  },
  {
    path: '/usuarios',
    name: 'usuarios',
    component: () => import('../views/Usuarios.vue'),
  },
  {
    path: '/sedes',
    name: 'sedes',
    component: () => import('../views/Sedes.vue'),
  },
  {
    path: '/sedesmod',
    name: 'sedesmod',
    component: () => import('../views/Sedes-mod.vue'),
  },
  {
    path: '/sedesadd',
    name: 'sedesadd',
    component: () => import('../views/Sedes-add.vue'),
  },
  {
    path: '/usuarioadd',
    name: 'usuarioadd',
    component: () => import('../views/Usuario-add.vue'),
  },
  {
    path: '/usuariomod',
    name: 'usuariomod',
    component: () => import('../views/Usuario-mod.vue'),
  },
  {
    path: '/inscripcionadd',
    name: 'inscripcionadd',
    component: () => import('../views/Inscripcion-add.vue'),
  },
  {
    path: '/CertificateReady',
    name: 'certificate.ready',
    component: () => import('../views/ciberkids/CertificateReady.vue'),
  },
  {
    path: '/createInscripcionCK',
    name: 'createInscripcionCK',
    component: () => import('../views/ciberkids/CreateInscripcionCK.vue'),
  },
  {
    path: '/misinscripciones',
    name: 'misinscripciones',
    component: () => import('../views/MisInscripciones.vue'),
  },
  {
    path: '/misinscripciones2',
    name: 'misinscripciones2',
    component: () => import('../views/MisInscripciones2.vue'),
  },
  {
    path: '/cargos',
    name: 'cargos',
    component: () => import('../views/Cargos.vue'),
  },
  {
    path: '/cargoedit',
    name: 'cargoedit',
    component: () => import('../views/CargoEditar.vue'),
  },
  {
    path: '/contactos',
    name: 'contactos',
    component: () => import('../views/ContactosNuevo.vue'),
  },
  {
    path: '/contactosferia',
    name: 'contactosferia',
    component: () => import('../views/ContactosNuevoFeria.vue'),
  },
  {
    path: '/insferia',
    name: 'insferia',
    component: () => import('../views/InscritosNuevoFeria.vue'),
  },
  {
    path: '/contadoadd',
    name: 'contadoadd',
    component: () => import('../views/Contacto-add.vue'),
  },
  {
    path: '/excelcontactos',
    name: 'excelcontactos',
    component: () => import('../views/ExcelContactos.vue'),
  },
  {
    path: '/certificadostodos',
    name: 'certificadostodos',
    component: () => import('../views/CertificadosTodos.vue'),
  },
  {
    path: '/customrecibo',
    name: 'customrecibo',
    component: () => import('../views/Reciboestudiante.vue'),
  },
  {
    path: '/recibosesam',
    name: 'recibosesam',
    component: () => import('../views/RecibosEsam.vue'),
  },
  {
    path: '/AntiguosRecibos',
    name: 'AntiguosRecibos',
    component: () => import('../views/recibos/RecibosOld.vue'),
  },
  {
    path: '/pagos',
    name: 'pagos',
    component: () => import('../views/pagos-contable.vue'),
  },
  {
    path: '/recibo',
    name: 'recibo',
    component: () => import('../components/ARecibo.vue'),
  },
  {
    path: '/contadomod',
    name: 'contadomod',
    component: () => import('../views/Contacto-mod.vue'),
  },
  {
    path: '/semaforo',
    name: 'semaforo',
    component: () => import('../views/Semaforo2.vue'),
  },
  {
    path: '/xreporte',
    name: 'xreporte',
    component: () => import('../views/Semaforo2b.vue'),
  },
  {
    path: '/xreportec',
    name: 'xreportec',
    component: () => import('../views/Semaforo2c.vue'),
  },
  {
    path: '/xreporteporsede',
    name: 'xreporteporsede',
    component: () => import('../views/ReporteMarketing2.vue'),
  },
  {
    path: '/semaforoins',
    name: 'semaforoins',
    component: () => import('../views/SemaforosIns.vue'),
  },
  {
    path: '/semaforopro',
    name: 'semaforopro',
    component: () => import('../views/SemaforosPro.vue'),
  },
  {
    path: '/semaforosed',
    name: 'semaforosed',
    component: () => import('../views/SemaforosSed.vue'),
  },
  {
    path: '/semaforosline',
    name: 'semaforosline',
    component: () => import('../views/SemaforosLine.vue'),
  },
  {
    path: '/semaforomod',
    name: 'semaforomod',
    component: () => import('../views/Semaforo-mod.vue'),
  },
  {
    path: '/semaforoadd',
    name: 'semaforoadd',
    component: () => import('../views/Semaforo-add.vue'),
  },
  {
    path: '/asignaraula',
    name: 'asignaraula',
    component: () => import('../views/AsignarAulas.vue'),
  },
  {
    path: '/asignaciones',
    name: 'asignaciones',
    component: () => import('../views/Asignaciones.vue'),
  },
  {
    path: '/jitsi',
    name: 'jitsi',
    component: () => import('../views/Jitsi.vue'),
  },
  {
    path: '/perfil',
    name: 'perfil',
    component: () => import('../views/Perfil.vue'),
  },
  {
    path: '/perfilchange',
    name: 'perfilchange',
    component: () => import('../views/PerfilChange.vue'),
  },
  {
    path: '/datosaccesso',
    name: 'datosaccesso',
    component: () => import('../views/DatosAcceso.vue'),
  },
  {
    path: '/programains',
    name: 'programains',
    component: () => import('../views/Programa-ins.vue'),
  },
  {
    path: '/programains2',
    name: 'programains2',
    component: () => import('../views/Programa-ins2.vue'),
  },
  {
    path: '/programaview',
    name: 'programaview',
    component: () => import('../views/Programa-view.vue'),
  },
  {
    path: '/programamod',
    name: 'programamod',
    component: () => import('../views/programa-mod.vue'),
  },
  {
    path: '/programa/:id/configuracion-clases',
    name: 'programa-configuracion-clases',
    component: () => import('../views/programas/ConfiguracionClasesPrograma.vue'),
  },
  {
    path: '/cambiarPreins',
    name: 'cambiarPreins',
    component: () => import('../views/CambiarPreinscripcion.vue'),
  },
  {
    path: '/personas',
    name: 'personas',
    component: () => import('../views/Estudiantes.vue'),
  },
  {
    path: '/docentes',
    name: 'docentes',
    component: () => import('../views/Docentes.vue'),
  },
  {
    path: '/webinarcert',
    name: 'webinarcert',
    component: () => import('../views/WebinarCertificates.vue'),
  },
  {
    path: '/docentesadd',
    name: 'docentesadd',
    component: () => import('../views/DocentesAdd.vue'),
  },
  {
    path: '/addPeople',
    name: 'addPeople',
    component: () => import('../views/PeopleAdd.vue'),
  },
  {
    path: '/estudiantesmod',
    name: 'estudiantesmod',
    component: () => import('../views/Estudiantes-mod.vue'),
  },
  {
    path: '/xnotas',
    name: 'xnotas',
    component: () => import('../views/Notas.vue'),
  },
  {
    path: '/programasperson',
    name: 'programasperson',
    component: () => import('../views/ProgramasPersona.vue'),
  },
  {
    path: '/excelins',
    name: 'excelins',
    component: () => import('../views/ExcelInscripciones.vue'),
  },
  {
    path: '/certificado',
    name: 'certificado',
    component: () => import('../views/Certificado.vue'),
  },
  {
    path: '/plataformas',
    name: 'plataformas',
    component: () => import('../views/Plataformas.vue'),
  },
  {
    path: '/excelinsprograma',
    name: 'excelinsprograma',
    component: () => import('../views/ExcelInsProgramas.vue'),
  },
  {
    path: '/cursoidmoodle',
    name: 'cursoidmoodle',
    component: () => import('../views/CursosMoodle-add.vue'),
  },
  {
    path: '/touser',
    name: 'touser',
    component: () => import('../views/Persona-touser.vue'),
  },
  {
    path: '/instituciones',
    name: 'instituciones',
    component: () => import('../views/Universidades.vue'),
  },
  {
    path: '/profesiones',
    name: 'profesiones',
    component: () => import('../views/Profesiones.vue'),
  },
  {
    path: '/ciudades',
    name: 'ciudades',
    component: () => import('../views/Ciudades.vue'),
  },
  {
    path: '/programarestadd',
    name: 'programarestadd',
    component: () => import('../views/programarest-add.vue'),
  },
  {
    path: '/inscripcionrest',
    name: 'inscripcionrest',
    component: () => import('../views/Inscripcionrest-add.vue'),
  },
  {
    path: '/inscripcionrestx',
    name: 'inscripcionrestx',
    component: () => import('../views/Inscripcionrestx-add.vue'),
  },
  {
    path: '/reporte_t4',
    name: 'reporte_t4',
    component: () => import('../views/prospectos1/reporte-contactos_t4.vue'),
  },
  {
    path: '/regularizar',
    name: 'regularizar',
    component: () => import('../views/InscripcionrestTwo.vue'),
  },
  {
    path: '/cambioplan',
    name: 'cambioplan',
    component: () => import('../views/InscripcionrestThree.vue'),
  },
  {
    path: '/programaviewrest',
    name: 'programaviewrest',
    component: () => import('../views/Programa-viewrest.vue'),
  },
  {
    path: '/programa_reg_from_oferta',
    name: 'programa_reg_from_oferta',
    component: () => import('../views/programa_reg_from_oferta/index.vue'),
  },
  {
    path: '/prospectos1',
    name: 'prospectos1',
    component: () => import('../views/prospectos1/index.vue'),
  },
  {
    path: '/prospectos_ins/:programa_id',
    name: 'prospectos_ins',
    component: () => import('../views/prospectos1/inscripcion/index_ins.vue'),
  },
  {
    path: '/pre_registros_mkt',
    name: 'pre_registros_mkt',
    component: () => import('../views/prospectos1/index_preregistros.vue'),
  },
  {
    path: '/descuentoslista',
    name: 'descuentoslista',
    component: () => import('../views/DescuentosLista.vue'),
  },
  {
    path: '/facturaslista',
    name: 'facturaslista',
    component: () => import('../views/ListaDeFacturas.vue'),
  },
  {
    path: '/facturaslistaext',
    name: 'facturaslistaext',
    component: () => import('../views/ListaDeFacturasExterno.vue'),
  },
  {
    path: '/programa-contrato',
    name: 'programa-contrato',
    component: () => import('../views/programa-contrato.vue'),
  },
  {
    path: '/programa-contrato-pdf',
    name: 'programa-contrato-pdf',
    component: () => import('../views/programa-contrato-pdf.vue'),
  },
  {
    path: '/contratocreator',
    name: 'contratocreator',
    component: () => import('../views/programa-contrato-creator.vue'),
  },
  {
    path: '/programa-contrato-template',
    name: 'programa-contrato-template',
    component: () => import('../views/programa-contrato-template.vue'),
  },
  {
    path: '/motivos-descuento',
    name: 'motivos-descuento',
    component: () => import('../views/Motivoscrud.vue'),
  },
  {
    path: '/asignacionesv2',
    name: 'asignacionesv2',
    component: () => import('../views/Asignacionesv2.vue'),
  },
  {
    path: '/asignacionesv2s',
    name: 'asignacionesv2s',
    component: () => import('../views/Asignacionesv2s.vue'),
  },
  {
    path: '/asignacionesv2ts',
    name: 'asignacionesv2ts',
    component: () => import('../views/Asignacionesv2ts.vue'),
  },
  {
    path: '/asignacionesv2tsp',
    name: 'asignacionesv2tsp',
    component: () => import('../views/Asignacionesv2tsp.vue'),
  },
  {
    path: '/recaudacionv4',
    name: 'recaudacionv4',
    component: () => import('../views/Recaudacionv4.vue'),
  },
  {
    path: '/recaudacionv8',
    name: 'recaudacionv8',
    component: () => import('../views/Recaudacionv8.vue'),
  },

  {
    path: '/asignacionesv2r',
    name: 'asignacionesv2r',
    component: () => import('../views/Asignacionesv2r.vue'),
  },
  {
    path: '/asignacionesv2un',
    name: 'asignacionesv2un',
    component: () => import('../views/Asignacionesv2un.vue'),
  },
  {
    path: '/asignacionesv2c',
    name: 'asignacionesv2c',
    component: () => import('../views/Asignacionesv2c.vue'),
  },
  {
    path: '/asignacionesconvenio',
    name: 'asignacionesconvenio',
    component: () => import('../views/AsignacionesConvenio.vue'),
  },
  {
    path: '/asignacionesconveniorecau',
    name: 'asignacionesconveniorecau',
    component: () => import('../views/AsignacionesConvenioRecauda.vue'),
  },
  {
    path: '/calificacionesv2',
    name: 'calificacionesv2',
    component: () => import('../views/Calificacionesv2.vue'),
  },
  {
    path: '/programacobradores',
    name: 'programacobradores',
    component: () => import('../views/Programa-cobradores.vue'),
  },
  {
    path: '/asignacionesmenu',
    name: 'asignacionesmenu',
    component: () => import('../views/AsignacionesMenu.vue'),
  },
  {
    path: '/formulariopdf',
    name: 'formulariopdf',
    component: () => import('../components/AFormularioPDF.vue'),
  },
  {
    path: '/editarplanpagos',
    name: 'editarplanpagos',
    component: () => import('../components/AEditarPlanPagos.vue'),      
  },
  {
    path: '/contratoslista',
    name: 'contratoslista',
    component: () => import('../views/ContratosLista.vue'),
  },
  {
    path: '/recibosbenito',
    name: 'recibosbenito',
    component: () => import('../views/recibos/RecibosList.vue'),
  },
  {
    path: '/agrupadorprogramas',
    name: 'agrupadorprogramas',
    component: () => import('../views/Agrupadorprogramas.vue'),
  },
  {
    path: '/xprogramas',
    name: 'xprogramas',
    component: () => import('../views/XProgramas.vue'),
  },
  {
    path: '/unidades',
    name: 'unidades',
    component: () => import('../views/unidades/Unidades.vue'),
  },
  {
    path: '/conceptospago',
    name: 'conceptospago',
    component: () => import('../views/conceptos/Conceptospago.vue'),
  },
  {
    path: '/conceptospagobyunidad',
    name: 'conceptospagobyunidad',
    component: () => import('../views/conceptos/Conceptospagobyunidad.vue'),
  },
  {
    path: '/xsucursales',
    name: 'xsucursales',
    component: () => import('../views/Sucursales/Sucursales.vue'),
  },
  {
    path: '/personasbyrol',
    name: 'personasbyrol',
    component: () => import('../views/PersonasByRol.vue'),
  },
  {
    path: '/certificacionestram',
    name: 'certificacionestram',
    component: () => import('../views/Certificacionestram.vue'),
  },
  {
    path: '/certtramites',
    name: 'certtramites',
    component: () => import('../views/CertTramites.vue'),
  },
  {
    path: '/proyectosmenu',
    name: 'proyectosmenu',
    component: () => import('../views/sigloxx/menu.vue'),
  },
  {
    path: '/proyectoshabilitacion',
    name: 'proyectoshabilitacion',
    component: () => import('../views/sigloxx/habilitacion.vue'),
  },
  {
    path: '/proyectosentrega',
    name: 'proyectosentrega',
    component: () => import('../views/sigloxx/entrega.vue'),
  },
  {
    path: '/proyectoslistado',
    name: 'proyectoslistado',
    component: () => import('../views/sigloxx/listado.vue'),
  },
  {
    path: '/proyectosconsolidar',
    name: 'proyectosconsolidar',
    component: () => import('../views/sigloxx/consolidar.vue'),
  },
  {
    path: '/datosfacturaele',
    name: 'datosfacturaele',
    component: () => import('../views/recibos/menufacturasele.vue'),
  },
  {
    path: '/clientes',
    name: 'clientes',
    component: () => import('../views/recibos/clientes/clientes.vue'),
  },
  {
    path: '/documentos',
    name: 'documentos',
    component: () => import('../views/recibos/documentos/documentos.vue'),
  },
  {
    path: '/fpagos',
    name: 'fpagos',
    component: () => import('../views/recibos/fpagos/fpagos.vue'),
  },
  {
    path: '/umedidas',
    name: 'umedidas',
    component: () => import('../views/recibos/umedidas/umedidas.vue'),
  },
  {
    path: '/pventas',
    name: 'pventas',
    component: () => import('../views/recibos/pventas/puntos.vue'),
  },
  {
    path: '/eventossig',
    name: 'eventossig',
    component: () => import('../views/recibos/esignificativos/eventos.vue'),
  },
  {
    path: '/eventossigenvios',
    name: 'eventossigenvios',
    component: () => import('../views/recibos/esignificativos/verenvios.vue'),
  },
  {
    path: '/emisionpaquetes',
    name: 'emisionpaquetes',
    component: () => import('../views/recibos/emisionpaq/emisionpaquetes.vue'),
  },
  {
    path: '/emisionmasivo',
    name: 'emisionmasivo',
    component: () => import('../views/recibos/emisionmasiva/emisionmasiva.vue'),
  },
  {
    path: '/emisionmasivoenvios',
    name: 'emisionmasivoenvios',
    component: () => import('../views/recibos/emisionmasiva/verenviosmasivos.vue'),
  },
  {
    path: '/cufds',
    name: 'cufds',
    component: () => import('../views/recibos/cufds/cufds.vue'),
  },
  {
    path: '/facturaspendientes',
    name: 'facturaspendientes',
    component: () => import('../views/recibos/factpendientes/facturaspen.vue'),
  },
  {
    path: '/eventosbypuntos',
    name: 'eventosbypuntos',
    component: () => import('../views/recibos/esignificativos/eventosbypunto.vue'),
  },
  {
    path: '/asignacionsede',
    name: 'asignacionsede',
    component: () => import('../views/Sucursales/Asignacionsedes.vue'),
  },
  {
    path: '/sucursalesbysede',
    name: 'sucursalesbysede',
    component: () => import('../views/Sucursales/sucursalesBySede.vue'),
  },
  {
    path: '/sedesbysucursal',
    name: 'sedesbysucursal',
    component: () => import('../views/Sucursales/sedesBySucursal.vue'),
  },
  {
    path: '/cafc',
    name: 'cafc',
    component: () => import('../views/recibos/cafc/cafc.vue'),
  },
  {
    path: '/sincronizar',
    name: 'sincronizar',
    component: () => import('../views/recibos/sincronizar.vue'),
  },
  {
    path: '/factura',
    name: 'factura',
    component: () => import('../views/facturasoffline/viewfactura.vue'),
  },
  {
    path: '/facturascv',
    name: 'facturascv',
    component: () => import('../views/rfacturascv/facturascv.vue'),
  },
  {
    path: '/facturascv2',
    name: 'facturascv2',
    component: () => import('../views/rfacturascv/facturascv2.vue'),
  },
  {
    path: '/facturased',
    name: 'facturased',
    component: () => import('../views/rfacturased/facturased.vue'),
  },
  {
    path: '/dosificacionesx',
    name: 'dosificacionesx',
    component: () => import('../views/dosificacionesx/dosis.vue'),
  },
  {
    path: '/notasdc',
    name: 'notasdc',
    component: () => import('../views/recibos/notas/notas.vue'),
  },
  {
    path: '/sincroonline',
    name: 'sincroonline',
    component: () => import('../views/recibos/sincroOnline.vue'),
  },
  {
    path: '/calificaciones',
    name: 'calificaciones',
    component: () => import('../views/calificaciones/calificaciones.vue'),
  },
  {
    path: '/calificaciones_reg',
    name: 'calificaciones_reg',
    component: () => import('../views/calificaciones/calificaciones-reg.vue'),
  },
  {
    path: '/asignacion_prog_v2',
    name: 'asignacion_prog_v2',
    component: () => import('../views/Asignacion_prog_v2.vue'),
  },
  {
    path: '/asignacion_prog_v4',
    name: 'asignacion_prog_v4',
    component: () => import('../views/Asignacion_prog_v4.vue'),
  },
  {
    path: '/asignacion_sede_v4',
    name: 'asignacion_sede_v4',
    component: () => import('../views/Asignacion_sede_v4.vue'),
  },
  {
    path: '/asignaciones-v8',
    name: 'AsignacionesV8',
    component: () => import('../views/Asignaciones_seedee_v8.vue'),
  },
  {
    path: '/asignacion_sede_v7',
    name: 'asignacion_sede_v7',
    component: () => import('../views/Asignaciones_sede_v7.vue'),
  },
  {
    path: '/asignacion_ejecutivo_v8',
    name: 'asignacion_ejecutivo_v8',
    component: () => import('../views/Asignaciones_ejecutivo_v8.vue'),
  },
  {
    path: '/asignacion_prog_v3',
    name: 'asignacion_prog_v3',
    component: () => import('../views/Asignacion_prog_v3.vue'),
  },
  {
    path: '/asignacion_sede_v2',
    name: 'asignacion_sede_v2',
    component: () => import('../views/Asignacion_sede_v2.vue'),
  },
  {
    path: '/asignacion_negounidad_v2',
    name: 'asignacion_negounidad_v2',
    component: () => import('../views/Asignacion_negounidad_v2.vue'),
  },
  {
    path: '/asignacion_corporacion_v2',
    name: 'asignacion_corporacion_v2',
    component: () => import('../views/Asignacion_corporacion_v2.vue'),
  },
  {
    path: '/modulo_edit',
    name: 'modulo_edit',
    component: () => import('../views/programas/modulo_edit.vue'),
  },
  {
    path: '/promociones',
    component: () => import('../views/promociones/lista.vue'),
  },
  {
    path: '/promociones-v2',
    component: () => import('../views/promociones/lista-v2.vue'),
  },
  {
    path: '/promociones-v3',
    component: () => import('../views/promociones/lista-v3.vue'),
  },
  {
    path: '/promociones-v3/nueva',
    component: () => import('../views/promociones/promo-create-v3.vue'),
  },
  {
    path: '/promociones-v3/:id/editar',
    component: () => import('../views/promociones/promo-create-v3.vue'),
  },
  {
    path: '/promociones-v3/:id',
    component: () => import('../views/promociones/promo-detail-v3.vue'),
  },
  {
    path: '/retrasosprog',
    component: () => import('../views/retrasos/index.vue'),
  },
  {
    path: '/pagos_templates',
    component: () => import('../views/programas/plan-templates.vue'),
  },
  {
    path: '/proy_unidad',
    name: 'proy_unidad',
    component: () => import('../views/proyecciones/proy-unidad.vue'),
  },
  {
    path: '/proy_programas',
    name: 'proy_programas',
    component: () => import('../views/proyecciones/proy-programas.vue'),
  },
  {
    path: '/proy_sedes',
    name: 'proy_sedes',
    component: () => import('../views/proyecciones/proy-sedes.vue'),
  },
  {
    path: '/proy_corporacion',
    name: 'proy_corporacion',
    component: () => import('../views/proyecciones/proy-corporacion.vue'),
  },
  {
    path: '/asig_total_unidad',
    name: 'asig_total_unidad',
    component: () => import('../views/asigtotales/unidad.vue'),
  },
  {
    path: '/asig_total_sede',
    name: 'asig_total_sede',
    component: () => import('../views/asigtotales/sede.vue'),
  },
  {
    path: '/asig_total_programa',
    name: 'asig_total_programa',
    component: () => import('../views/asigtotales/programa.vue'),
  },
  {
    path: '/asig_total_corporacion',
    name: 'asig_total_corporacion',
    component: () => import('../views/asigtotales/corporacion.vue'),
  },

  /*  */
  {
    path: '/agrupadores',
    name: 'agrupadores',
    component: () => import('../views/agrupadores/index.vue'),
  },
  {
    path: '/asig_total_corpo',
    name: 'asig_total_corpo',
    component: () => import('../views/Asignacionesv2cor.vue'),
  },
  {
    path: '/asig_total_prog',
    name: 'asig_total_prog',
    component: () => import('../views/Asignacionesv2pro.vue'),
  },
  {
    path: '/verificador_cobranzas',
    name: 'verificador_cobranzas',
    component: () => import('../views/verificar/cobranzas.vue'),
  },
  {
    path: '/oferta_acadenika',
    name: 'oferta_acadenika',
    component: () => import('../views/programas/oferta/index.vue'),
  },
  {
    path: '/reportestitulacionesprograma',
    name: 'reportestitulacionesprograma',
    component: () => import('../views/reportestitulaciones/por_programa.vue'),
  },

  {
    path: '/reportestitulacionessede',
    name: 'reportestitulacionessede',
    component: () => import('../views/reportestitulaciones/por_sede.vue'),
  },
  {
    path: '/menureportetitulaciones',
    name: 'menureportetitulaciones',
    component: () => import('../views/ReporteTitulacionesMenu.vue'),
  },
  {
    path: '/migracionacademico',
    name: 'migracionacademico',
    component: () => import('../views/migracionacademico/index.vue'),
  },
  {
    path: '/estados_tit',
    name: 'estados_tit',
    component: () => import('../views/reportestitulaciones/estados_titulacion.vue'),
  },
  {
    path: '/nominaciones',
    name: 'nominaciones',
    component: () => import('../views/nominaciones/index.vue'),
  },
  {
    path: '/cajas',
    name: 'cajas',
    component: () => import('../views/nominaciones/cajas/index.vue'),
  },
  {
    path: '/depositos',
    name: 'depositos',
    component: () => import('../views/nominaciones/depositos/index.vue'),
  },
  {
    path: '/depositosede',
    name: 'depositosede',
    component: () => import('../views/nominaciones/cajas/depositosBysede.vue'),
  },
  {
    path: '/moduloopciones',
    name: 'moduloopciones',
    component: () => import('../views/programas/modulo-opciones.vue'),
  },
  {
    path: '/reportecuenta',
    name: 'reportecuenta',
    component: () => import('../views/programas/reportecuenta.vue'),
  },
  {
    path: '/depositostodepos',
    name: 'depositostodepos',
    component: () => import('../views/nominaciones/depositos/depositosTodepositos.vue'),
  },
  {
    path: '/getwebinars',
    name: 'getwebinars',
    component: () => import('../views/programas/getWebinars.vue'),
  },
  {
    path: '/asig_envios_a_netsuite',
    name: 'asig_envios_a_netsuite',
    component: () => import('../views/enviosnetsuite/envios_netsuite.vue'),
  },
  {
    path: '/editperson',
    name: 'editperson',
    component: () => import('../components/ti/edit_persona.vue'),
  },
  {
    path: '/oferta_academica',
    name: 'oferta_academica',
    component: () => import('@/views/oferta_academica/index_oferta.vue'),
  },
  {
    path: '/oferta_oficial_esam',
    name: 'oferta_oficial_esam',
    component: () => import('@/views/oferta_academica/oficial/lista-oficial-esam.vue'),
  },
  {
    path: '/oferta_oficial_dbs',
    name: 'oferta_oficial_dbs',
    component: () => import('@/views/oferta_academica/oficial/lista-oficial-dbs.vue'),
  },
  {
    path: '/oferta_autoria',
    name: 'oferta_autoria',
    component: () => import('@/views/oferta_academica/autoria/index_autoria.vue'),
  },
  {
    path: '/oferta_autoria_sel',
    name: 'oferta_autoria_sel',
    component: () => import('@/views/oferta_academica/autoria_seleccionar/autoria-index.vue'),
  },
  {
    path: '/oferta_libre',
    name: 'oferta_libre',
    component: () => import('@/views/oferta_academica/libre/index_libre.vue'),
  },
  {
    path: '/oferta_rendimiento',
    name: 'oferta_rendimiento',
    component: () => import('@/views/oferta_academica/rendimiento/index_rendimiento.vue'),
  },
  {
    path: '/oferta_general',
    name: 'oferta_general',
    component: () => import('@/views/oferta_academica/uno_general/general-index.vue'),
  },
  {
    path: '/oferta_regularizar',
    name: 'oferta_regularizar',
    component: () => import('@/views/oferta_academica/uno_general/regularizar-esam.vue'),
  },
  {
    path: '/consolidarfact',
    name: 'consolidarfact',
    component: () => import('@/views/consolidarfact/index.vue'),
  },
  {
    path: '/programas-fechas-proyectadas',
    name: 'programas.fechas.proyectadas',
    component: () => import('@/views/programas/FechasProyectadas.vue'),
  },
  {
    path: '/programas-fechas-proyectadas-listado',
    name: 'programas.fechas.proyectadas.listado',
    component: () => import('@/views/programas/FechasProyectadasListado.vue'),
  },
  {
    path: '/solicitudes-fecha-matriculacion',
    name: 'solicitudes.fecha.matriculacion',
    component: () => import('@/views/programas/SolicitudesFechaMatriculaListado.vue'),
  },
  {
    path: '/solicitudes-anticipo-modulo',
    name: 'solicitudes.anticipo.modulo',
    component: () => import('@/views/programas/SolicitudesAnticipoModuloListado.vue'),
  },
  {
    path: '/solicitudes-configuracion-clases',
    name: 'solicitudes.configuracion.clases',
    component: () => import('@/views/programas/SolicitudesConfiguracionClasesListado.vue'),
  },
  {
    path: '/bandeja-arrastre',
    name: 'bandeja.arrastre',
    component: () => import('@/views/programas/BandejaArrastre.vue'),
  },
  {
    path: '/solicitudes-dado-de-baja',
    name: 'solicitudes.dado.de.baja',
    component: () => import('@/views/programas/SolicitudesDadoDeBajaListado.vue'),
  },
  /*  */
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/programas/:programaId/certificados/universidad/:universidadId',
    name: 'CertificadoUniversidad',
    component: () => import('@/views/CertificadoUniversidad.vue'),
    // props: true
  },
  {
    path: '/programasuniversidad/:programaId',
    name: 'CertificadoUniversidad',
    component: () => import('@/views/ProgramasUniversidad.vue'),
    // props: true
  },
  {
    path: '/programasuniversidadcertificados',
    name: 'programasuniversidadcertificados',
    component: () => import('@/views/ProgramaUniversidadCertificadosManager'),
    // props: true
  },
  {
    path: '/solicitudesuniversidadcertificados',
    name: 'solicitudesuniversidadcertificados',
    component: () => import('@/views/SolicitudesCertificado.vue'),
    // props: true
  },
  {
    path: '/solicitudes-cambio-programa',
    name: 'solicitudes.cambio.programa',
    component: () => import('@/views/programas/SolicitudesCambioProgramaListado.vue'),
  },
  {
    path: '/conciliaciones',
    name: 'conciliaciones',
    component: () => import('@/views/ConciliacionManual.vue'),
    // props: true
  },
  {
    path: '/conciliacion-bancaria',
    name: 'conciliacion-bancaria',
    component: () => import('@/views/conciliacion/ConciliacionBancaria.vue'),
  },
  {
    path: '/conciliacion-efectivo',
    name: 'conciliacion-efectivo',
    component: () => import('@/views/conciliacion/ConciliacionEfectivo.vue'),
  },
  {
    path: '/extractos',
    name: 'extractos',
    component: () => import('@/views/Extractos.vue'),
    // props: true
  },
  {
    path: '/agregarconcepto',
    name: 'agregarconcepto',
    component: () => import('../components/AgregarConceptoPago.vue'),
    props: true,
  },
  {
    path: '/generar_plan_upi/:idprograma', 
    name: 'generar_plan_upi',
    // component: () => import('@/views/upi/planes/plan-index.vue'),
    component: () => import('@/views/upi/planes/plan_new_q.vue'),
   // props: true
  },
  {
    path: '/generar_plan_upi_q/:idprograma', 
    name: 'generar_plan_upi_q',
    component: () => import('@/views/upi/planes/plan_new_q.vue'),
   // props: true
  },
  {
    path: '/terminos-condiciones', 
    name: 'terminos_condiciones',
    component: () => import('@/views/prospectos1/terminos-condiciones.vue'),
   // props: true
  },
  {
    path: '/reporte-contactos', 
    name: 'reporte_contactos',
    component: () => import('@/views/prospectos1/reporte-contactos.vue'),
   // props: true
  },
  ...presupuestoRouter,
  ...pagosRouter,
  ...comisionesRouter,
  // ...gastosRoutes,
  ...documentosInscripcionesRoutes,
  ...calificacionesRoutes,
  ...docentesSeguimientoRoutes,
];

const router = new VueRouter({
  //mode: 'history',
  //mode: 'history',
  base: '/' + process.env.VUE_APP_BASE_URL,
  linkActiveClass: 'is-active',
  routes,
});

export default router;
